<div class="mb-3">
  <!-- Label -->
  <label [for]="'customUser' + name" class="form-label">{{title}}</label>

  <div class="row gx-3 align-items-baseline">

    <!-- Use default checkbox -->
    <div class="col">
      <input type="checkbox" class="form-check-input me-2" [id]="'useDefault' + name"
        [checked]="useDefaultValue()" (change)="checkboxCheckedChanged($event)" />
      <label [for]="'useDefault' + name" class="form-label">Use default {{title}}</label>
    </div>

  </div>
  
  <div class="row gx-3 align-items-baseline">

    <!-- Input field -->
    <div class="col">
      <input type="text" [ngModel]="inputValue()" [disabled]="useDefaultValue()" (change)="inputValueChange($event)"
        class="form-control" [id]="'customUser' + name"
        placeholder="Enter {{title}}..." style="display: inline;" />
    </div>

  </div>

</div>